"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoxboneRegulationAddressTypeEnum = void 0;
var VoxboneRegulationAddressTypeEnum;
(function (VoxboneRegulationAddressTypeEnum) {
    VoxboneRegulationAddressTypeEnum["LOCAL"] = "LOCAL";
    VoxboneRegulationAddressTypeEnum["WORLDWIDE"] = "WORLDWIDE";
    VoxboneRegulationAddressTypeEnum["NATIONAL"] = "NATIONAL";
})(VoxboneRegulationAddressTypeEnum = exports.VoxboneRegulationAddressTypeEnum || (exports.VoxboneRegulationAddressTypeEnum = {}));
